import { ComisionesF } from "@/cuentas/ComisionesF";
import { GET } from "@/state/api";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const SearchZod = z.object({
  temporada_id: z.number(),
  fotografo_id: z.number(),
});

export const Route = createFileRoute("/admin/comisionesF")({
  component: RouteComponent,
  validateSearch: SearchZod,
  loader: async (params) =>
    (
      await GET("/admin/comisiones/:temporada_id/:fotografo_id", {
        p: params.location.search as z.infer<typeof SearchZod>,
      })
    ).miscomisiones,
});

function RouteComponent() {
  const search = Route.useSearch();
  const data = Route.useLoaderData();

  return <ComisionesF {...{ data, ...search }} />;
}
